<style scoped>
    @import url("../../../styles/contadorAguaPage/v3/dialogB.scss");
</style>

<template>
    <div class="box_dialogB">

        <div class="session_form mb-2 mt-2" v-if="flag_loading">

            <span class="mb-2" :style="{'font-size':'0.7rem'}">Atualizando suas informações</span>

            <v-progress-circular
            :size="70"
            :width="7"
            color="green"
            indeterminate
            :style="{'display':'flex','align-self':'center'}"
            ></v-progress-circular>

        </div>

        <v-icon class="mt-4" :style="{'color':'rgb(31,122,177)'}">{{ icon }}</v-icon>

        <div class="tit" v-if="!flag_loading && !flagMsg">{{ t }}</div>

        <div class="subtit mt-4" v-if="!flag_loading && !flagMsg">
            {{ msgSubTit }}
        </div>
        <!-- Atenção. Esta ação é irreversível. -->

        <div v-if="!flag_loading && !flagMsg" class="btn_login mt-4 mb-2">
            
            <v-btn
            small
            block
            :color=colorBtnCall
            class="mr-4 mt-1"
            @click="chamada(true)"
            >
                {{ titBtnCall }}
            </v-btn>

            <v-btn
            small
            block
            color="primary"
            class="mr-4 mt-1"
            @click="chamada(false)"
            >
                Cancelar
            </v-btn>
        </div>

        <span v-if="flagMsg && !flag_loading"
        :style="{'margin-top':'10px','color':colorMsg,'font-size':'0.8rem'}">
            {{ msg }}
        </span>

    </div>
</template>

<script>
//import axios from 'axios'

export default {

    props:['t','icon','flagStrTipoDialog','idMalha','idGrupo','idIN','idOUT'],

    data() {
        return {
            flagMsg:false,
            colorMsg:'red',
            msg:'Falha ao tentar deletar',
            flag_loading:false,

            msgSubTit:'O item ainda ficará visível. Com status desativado.',
            colorBtnCall:'red',
            titBtnCall:'Desativar',

            qntMalhas:0,
            malhas:[],
            qntGrupos:0,
            grupos:[],
        }
    },

    methods: {

        deletarM() {
            this.malhas = this.$store.state.liMalhas // list from store
            this.qntMalhas = this.malhas.length // int

            var liNovaMalha = []
            var novoId = 0
            var m = 0
            while (m < this.qntMalhas) {

                if (m == this.idMalha) {
                    novoId++ // contar mais 1 para eliminar/pular o elemento atual.
                }

                // -- Se o deletado não for o último elemento da lista.
                // -- Então continuar o reposicionamento.
                if (m < this.qntMalhas-1) {
                    this.malhas[novoId].id = m // reposicionar id deletado.
                    liNovaMalha[m] = this.malhas[novoId]
                }

                novoId++
                m = novoId
            }

            this.$store.state.liMalhas = liNovaMalha // list to store
            this.msg = 'Malha deletada. Você será redirecionado.'
            this.colorMsg = 'green'
            this.flagMsg = true
            setTimeout(() => {
                this.flag_loading = false // reset loading
                this.$emit('fromDel',[false,'delete',this.flagStrTipoDialog]) // desable dialog.
            },3000)
        },

        deletar() {
            // processar: obter todos os nomes de tudo?

            this.malhas = this.$store.state.liMalhas // list from store
            var m = this.idMalha // via props

            //console.log('this.malhas[m].malha: ',this.malhas[m].malha)
            this.qntGrupos = this.malhas[m].grupos.length // int
            //console.log('this.qntGrupos: ',this.qntGrupos)
            this.grupos = this.malhas[m].grupos // list

            var novaListaGrupos = []
            var novoId = 0
            var c = 0
            while (c < this.qntGrupos) {
                //console.log('this.grupos[c].grupo: ',this.grupos[c].grupo)
                //console.log('c: ',c)
                //console.log('novoId: ',novoId)

                if (c == this.idGrupo) {
                    //console.log('grupo a deletar é: ',this.idGrupo)
                    novoId++ // contar mais 1 para eliminar/pular o elemento atual.
                }

                // -- Se o deletado não for o último elemento da lista.
                // -- Então continuar o reposicionamento.
                if (novoId < this.qntGrupos) {
                    this.grupos[novoId].id = c // reposicionar id deletado.
                    this.malhas[m].grupos[c] = this.grupos[novoId] // grupo [ c + 1 ]
                    novaListaGrupos.push(this.malhas[m].grupos[c])
                }

                novoId++
                c = novoId
            }

            this.$store.state.liMalhas[m].grupos = novaListaGrupos // list to store
            this.msg = 'Grupo deletado. Você será redirecionado.'
            this.colorMsg = 'green'
            this.flagMsg = true
            setTimeout(() => {
                this.flag_loading = false // reset loading
                this.$emit('fromDel',[false,'delete',this.flagStrTipoDialog]) // desable dialog.
            },3000)
        },

        deletarIN() {
            var m = this.idMalha // via props
            var c = this.idGrupo // via props
            //console.log(`[del] IN | malha ${m} | grupo ${c}`)

            this.malhas = this.$store.state.liMalhas // list from store
            var tmpLiIN = this.$store.state.liMalhas[m].grupos[c].entradas // list

            var novaListaIN = []
            var novoId = 0
            var i = 0
            while (i < tmpLiIN.length) {

                if (i == this.idIN) {
                    novoId++ // contar mais 1 para eliminar/pular o elemento atual.
                }

                // -- Se o deletado não for o último elemento da lista.
                // -- Então continuar o reposicionamento.
                if (novoId < tmpLiIN.length) {
                    tmpLiIN[novoId].id = i // entrada [ i + 1 ] <- id == i (reposicionar id deletado).
                    this.malhas[m].grupos[c].entradas[i] = tmpLiIN[novoId] // entrada [ i + 1 ]
                    novaListaIN.push(this.malhas[m].grupos[c].entradas[i])
                }

                novoId++
                i = novoId
            }
            this.$store.state.liMalhas[m].grupos[c].entradas = novaListaIN // list to store
            this.msg = 'Entrada deletada. Você será redirecionado.'
            this.colorMsg = 'green'
            this.flagMsg = true
            setTimeout(() => {
                this.flag_loading = false // reset loading
                this.$emit('fromDel',[false,'delete',this.flagStrTipoDialog]) // desable dialog.
            },2000)
        },

        deletarOUT() {
            var m = this.idMalha // via props
            var c = this.idGrupo // via props
            //console.log(`[del] IN | malha ${m} | grupo ${c}`)

            this.malhas = this.$store.state.liMalhas // list from store
            var tmpLiOUT = this.$store.state.liMalhas[m].grupos[c].saidas // list

            var novaListaOUT = []
            var novoId = 0
            var i = 0
            while (i < tmpLiOUT.length) {

                if (i == this.idOUT) {
                    novoId++ // contar mais 1 para eliminar/pular o elemento atual.
                }

                // -- Se o deletado não for o último elemento da lista.
                // -- Então continuar o reposicionamento.
                if (novoId < tmpLiOUT.length) {
                    tmpLiOUT[novoId].id = i // entrada [ i + 1 ] <- id == i (reposicionar id deletado).
                    this.malhas[m].grupos[c].saidas[i] = tmpLiOUT[novoId] // entrada [ i + 1 ]
                    novaListaOUT.push(this.malhas[m].grupos[c].saidas[i])
                }

                novoId++
                i = novoId
            }
            this.$store.state.liMalhas[m].grupos[c].saidas = novaListaOUT // list to store
            this.msg = 'Entrada deletada. Você será redirecionado.'
            this.colorMsg = 'green'
            this.flagMsg = true
            setTimeout(() => {
                this.flag_loading = false // reset loading
                this.$emit('fromDel',[false,'delete',this.flagStrTipoDialog]) // desable dialog.
            },2000)
        },

        desativarIN() {
            var m = this.idMalha // via props
            var c = this.idGrupo // via props
            //console.log(`[del] IN | malha ${m} | grupo ${c}`)

            this.malhas = this.$store.state.liMalhas // list from store
            var tmpLiIN = this.$store.state.liMalhas[m].grupos[c].entradas // list

            var i = 0
            while (i < tmpLiIN.length) {

                if (i == this.idIN) {
                    // Obter data de hoje.
                    const { getDataAtualGMT, getHoraAtualGMT } = require('../../../ferramentas/dataHoraGMT.js');

                    // -- modificar elemento selecionado.
                    var novoEvento = {
                        'data':getDataAtualGMT(),
                        'hora':getHoraAtualGMT(),
                        'origem':'entrada',
                        'tipo':'Desativação', // solicitado pelo cliente.
                        'nota':'-'
                    }
                    tmpLiIN[i]['status'] = 'Desativado'
                    tmpLiIN[i]['eventos'].push(novoEvento)
                    break
                }
                i++
            }
            this.$store.state.liMalhas[m].grupos[c].entradas = tmpLiIN // list to store
            this.msg = 'Entrada desativada. Você será redirecionado.'
            this.colorMsg = 'green'
            this.flagMsg = true
            setTimeout(() => {
                this.flag_loading = false // reset loading
                this.$emit('fromDel',[false,'des',this.flagStrTipoDialog]) // desable dialog.
            },2000)
        },

        desativarOUT() {
            var m = this.idMalha // via props
            var c = this.idGrupo // via props
            //console.log(`[del] IN | malha ${m} | grupo ${c}`)

            this.malhas = this.$store.state.liMalhas // list from store
            var tmpLiOUT = this.$store.state.liMalhas[m].grupos[c].saidas // list

            var i = 0
            while (i < tmpLiOUT.length) {

                if (i == this.idOUT) {
                    // Obter data de hoje.
                    const { getDataAtualGMT, getHoraAtualGMT } = require('../../../ferramentas/dataHoraGMT.js');

                    // -- modificar elemento selecionado.
                    var novoEvento = {
                        'data':getDataAtualGMT(),
                        'hora':getHoraAtualGMT(),
                        'origem':'saida',
                        'tipo':'Desativação', // solicitado pelo cliente.
                        'nota':'-'
                    }
                    tmpLiOUT[i]['status'] = 'Desativado'
                    tmpLiOUT[i]['eventos'].push(novoEvento)
                    break
                }
                i++
            }
            this.$store.state.liMalhas[m].grupos[c].saidas = tmpLiOUT // list to store
            this.msg = 'Saída desativada. Você será redirecionado.'
            this.colorMsg = 'green'
            this.flagMsg = true
            setTimeout(() => {
                this.flag_loading = false // reset loading
                this.$emit('fromDel',[false,'des',this.flagStrTipoDialog]) // desable dialog.
            },2000)
        },

        desativarG() {
            // processar: obter todos os nomes de tudo?

            this.malhas = this.$store.state.liMalhas // list from store
            var m = this.idMalha // via props

            this.qntGrupos = this.malhas[m].grupos.length // int
            this.grupos = this.malhas[m].grupos // list

            var c = 0
            while (c < this.qntGrupos) {

                if (c == this.idGrupo) {
                    this.grupos[c]['status'] = 'Desativado'
                    break
                }
                c++
            }

            this.$store.state.liMalhas[m].grupos = this.grupos // list to store
            this.msg = 'Grupo desativado. Você será redirecionado.'
            this.colorMsg = 'green'
            this.flagMsg = true
            setTimeout(() => {
                this.flag_loading = false // reset loading
                this.$emit('fromDes',[false,'des',this.flagStrTipoDialog]) // desable dialog.
            },3000)
        },

        desativarM() {
            this.malhas = this.$store.state.liMalhas // list from store
            this.qntMalhas = this.malhas.length // int

            var m = 0
            while (m < this.qntMalhas) {

                if (m == this.idMalha) {
                    this.malhas[m].status = 'Desativado'
                }
                m++
            }

            this.$store.state.liMalhas = this.malhas // list to store
            this.msg = 'Malha desativada. Você será redirecionado.'
            this.colorMsg = 'green'
            this.flagMsg = true
            setTimeout(() => {
                this.flag_loading = false // reset loading
                this.$emit('fromDes',[false,'des',this.flagStrTipoDialog]) // desable dialog.
            },3000)
        },

        reativarIN() {
            var m = this.idMalha // via props
            var c = this.idGrupo // via props
            //console.log(`[del] IN | malha ${m} | grupo ${c}`)

            this.malhas = this.$store.state.liMalhas // list from store
            var tmpLiIN = this.$store.state.liMalhas[m].grupos[c].entradas // list

            var i = 0
            while (i < tmpLiIN.length) {

                if (i == this.idIN) {
                    // Obter data de hoje.
                    const { getDataAtualGMT, getHoraAtualGMT } = require('../../../ferramentas/dataHoraGMT.js');

                    // -- modificar elemento selecionado.
                    var novoEvento = {
                        'data':getDataAtualGMT(),
                        'hora':getHoraAtualGMT(),
                        'origem':'entrada',
                        'tipo':'Reativação', // solicitado pelo cliente.
                        'nota':'-'
                    }
                    tmpLiIN[i]['status'] = 'Ativo'
                    tmpLiIN[i]['eventos'].push(novoEvento)
                    break
                }
                i++
            }
            this.$store.state.liMalhas[m].grupos[c].entradas = tmpLiIN // list to store
            this.msg = 'Entrada reativada. Você será redirecionado.'
            this.colorMsg = 'green'
            this.flagMsg = true
            setTimeout(() => {
                this.flag_loading = false // reset loading
                this.$emit('fromReat',[false,'reat',this.flagStrTipoDialog]) // desable dialog.
            },2000)
        },

        reativarOUT() {
            var m = this.idMalha // via props
            var c = this.idGrupo // via props
            //console.log(`[del] IN | malha ${m} | grupo ${c}`)

            this.malhas = this.$store.state.liMalhas // list from store
            var tmpLiOUT = this.$store.state.liMalhas[m].grupos[c].saidas // list

            var i = 0
            while (i < tmpLiOUT.length) {

                if (i == this.idOUT) {
                    // Obter data de hoje.
                    const { getDataAtualGMT, getHoraAtualGMT } = require('../../../ferramentas/dataHoraGMT.js');

                    // -- modificar elemento selecionado.
                    var novoEvento = {
                        'data':getDataAtualGMT(),
                        'hora':getHoraAtualGMT(),
                        'origem':'saida',
                        'tipo':'Reativação', // solicitado pelo cliente.
                        'nota':'-'
                    }
                    tmpLiOUT[i]['status'] = 'Ativo'
                    tmpLiOUT[i]['eventos'].push(novoEvento)
                    break
                }
                i++
            }
            this.$store.state.liMalhas[m].grupos[c].saidas = tmpLiOUT // list to store
            this.msg = 'Saída reativada. Você será redirecionado.'
            this.colorMsg = 'green'
            this.flagMsg = true
            setTimeout(() => {
                this.flag_loading = false // reset loading
                this.$emit('fromReat',[false,'reat',this.flagStrTipoDialog]) // desable dialog.
            },2000)
        },

        reativarG() {
            this.malhas = this.$store.state.liMalhas // list from store
            var m = this.idMalha // via props

            this.qntGrupos = this.malhas[m].grupos.length // int
            this.grupos = this.malhas[m].grupos // list

            var c = 0
            while (c < this.qntGrupos) {

                if (c == this.idGrupo) {
                    this.grupos[c]['status'] = 'Ativo'
                    break
                }
                c++
            }

            this.$store.state.liMalhas[m].grupos = this.grupos // list to store
            this.msg = 'Grupo Reativado. Você será redirecionado.'
            this.colorMsg = 'green'
            this.flagMsg = true
            setTimeout(() => {
                this.flag_loading = false // reset loading
                this.$emit('fromReat',[false,'reat',this.flagStrTipoDialog]) // desable dialog.
            },3000)
        },

        reativarM() {
            this.malhas = this.$store.state.liMalhas // list from store
            this.qntMalhas = this.malhas.length // int

            var m = 0
            while (m < this.qntMalhas) {

                if (m == this.idMalha) {
                    this.malhas[m].status = 'Ativo'
                }
                m++
            }

            this.$store.state.liMalhas = this.malhas // list to store
            this.msg = 'Malha reativada. Você será redirecionado.'
            this.colorMsg = 'green'
            this.flagMsg = true
            setTimeout(() => {
                this.flag_loading = false // reset loading
                this.$emit('fromReat',[false,'reat',this.flagStrTipoDialog]) // desable dialog.
            },3000)
        },

        chamada(flagConfirm) {

            if (flagConfirm == false) {
                //console.log('delete cancelado')
                this.msg = 'Operação cancelada.'
                this.flagMsg = true
                setTimeout(() => {
                    this.$emit('fromDes',[false,'des',this.flagStrTipoDialog]) // desable dialog.
                },2000)
                return
            }

            this.flag_loading = true // iniciar loading...

            // RODAR apagão! (APAGÃO SUBSTITUÍDO POR ALTERAÇÃO DE STATUS).
            //if (this.t == 'Deletar malha') { this.deletarM() }
            //if (this.t == 'Deletar grupo') { this.deletar() }
            //if (this.t == 'Deletar entrada') { this.deletarIN() }
            //if (this.t == 'Deletar saida') { this.deletarOUT() }

            // Desativação.
            if (this.t == 'Desativar entrada') { this.desativarIN() }
            if (this.t == 'Desativar saida') { this.desativarOUT() }
            if (this.t == 'Desativar grupo') { this.desativarG() }
            if (this.t == 'Desativar malha') { this.desativarM() }

            // REATIVAÇÃO.
            if (this.t == 'Reativar malha') { this.reativarM() }
            if (this.t == 'Reativar grupo') { this.reativarG() }
            if (this.t == 'Reativar entrada') { this.reativarIN() }
            if (this.t == 'Reativar saida') { this.reativarOUT() }
        },
    },

    created() {
        //this.$store.commit('srcIPloja') // without param. Initial main GET Req.

        const recorteTit = this.t.substring(0, 8)
        if (recorteTit == 'Reativar') {
            this.msgSubTit = 'O item ficará visível com status Ativo.'
            this.colorBtnCall = 'green'
            this.titBtnCall = 'Reativar'
        }
    }
}
</script>